export const assetManifestPixiLiteral = {
  bundles: [
    {
      name: 'splashScreen',
      assets: {
        lb_ship: 'https://staticcontent.knowledgehook.com/content/khg/student/lb/lb_ship.png',
        galaxy_full_dark: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/galaxy_full_dark.png',
        zr_loading_screen: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/zr_loading_screen.png'
      }
    },
    {
      name: 'lobby',
      assets: [
        {
          alias: 'lobby_ui',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/ui/lobby-scene/lobbyui.json'
        },
        {
          alias: 'tile_dirty_layer_lv1_64',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/misc/dirty_layer_lv1_64.png'
        },
        {
          alias: 'tile_dirty_layer_lv1_128',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/misc/dirty_layer_lv1_128.png'
        },
        {
          alias: 'tile_dirty_layer_lv2_64',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/misc/dirty_layer_lv2_64.png'
        },
        {
          alias: 'tile_dirty_layer_lv2_128',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/misc/dirty_layer_lv2_128.png'
        },
        {
          alias: 'tile_dirty_layer_lv1_debug',
          src: 'https://staticcontent.knowledgehook.com/content/khg/debug/tile-grid-orange-16.png'
        },
        {
          alias: 'tile_dirty_layer_lv2_debug',
          src: 'https://staticcontent.knowledgehook.com/content/khg/debug/tile-grid-red-16.png'
        },
        {
          alias: 'captureModeLobby',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/gamemap-thumb-capturepoint.png'
        },
        {
          alias: 'outpostRunLobby',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/gamemap-thumb-outpostrun.png'
        },
        {
          alias: 'lobbyLoaderAtlas',
          src: 'https://staticcontent.knowledgehook.com/content/khg/lobby-loader/lobby-loader.atlas'
        },
        {
          alias: 'lobbyLoaderSkeleton',
          src: 'https://staticcontent.knowledgehook.com/content/khg/lobby-loader/lobby-loader.json'
        },
        {
          alias: 'icon_ai_core',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/icon_core_default.png'
        },
        {
          alias: 'icon_boost',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/lobby-scene/icon_type_boost_highlight.png'
        },
        {
          alias: 'host_flag',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/icon_flag_glow.png'
        },
        {
          alias: 'checkmark_friendly',
          src: 'https://staticcontent.knowledgehook.com/content/icons/suggested/friendly/checkmark.svg',
          data: {
            parseAsGraphicsContext: true
          }
        },
        {
          alias: 'lobbyMusic',
          src: 'https://staticcontent.knowledgehook.com/content/khg/audio/soundtracks/soundtrack_lobby.mp3',
          data: {
            volume: 0.3,
            loop: true,
            speed: 1
          }
        },
        {
          alias: 'boost_equip',
          src: 'https://staticcontent.knowledgehook.com/content/khg/audio/sfx/ui/boost_is_equipped.mp3',
          data: {
            volume: 1,
            loop: false,
            speed: 1
          }
        },
        {
          alias: 'tutorial-tooltips',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/tutorials/tutorial-tooltips.json'
        }
      ]
    },
    {
      name: 'baseScene',
      assets: [
        {
          alias: 'tutorial-door-vertical.json',
          src: 'https://staticcontent.knowledgehook.com/content/khg/environments/tutorial-door/vertical-gate-skeleton.json'
        },
        {
          alias: 'tutorial-door-vertical.atlas',
          src: 'https://staticcontent.knowledgehook.com/content/khg/environments/tutorial-door/vertical-gate-skeleton.atlas'
        },
        {
          alias: 'tutorial-door-horizontal.json',
          src: 'https://staticcontent.knowledgehook.com/content/khg/environments/tutorial-door/horizontal-gate-skeleton.json'
        },
        {
          alias: 'tutorial-door-horizontal.atlas',
          src: 'https://staticcontent.knowledgehook.com/content/khg/environments/tutorial-door/horizontal-gate-skeleton.atlas'
        },
        {
          alias: 'zogear-helmet-dog',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_part_dog_default_helmet.png'
        },
        {
          alias: 'zogear-helmet-cat',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_part_cat_default_helmet.png'
        },
        {
          alias: 'zogear-helmet-pig',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_part_pig_default_helmet.png'
        },
        {
          alias: 'zogear-helmet-horse',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_part_horse_default_helmet.png'
        },
        {
          alias: 'zogear-helmet-sheep',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_part_sheep_default_helmet.png'
        },
        {
          alias: 'directionRing',
          src: 'https://staticcontent.knowledgehook.com/content/khg/misc/direction_ring_circle.png'
        },
        {
          alias: 'icon_item_currency_parts',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_currency_parts_v2.png'
        },
        {
          alias: 'icon_item_currency_questions',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_currency_questions.png'
        },
        {
          alias: 'icon_item_currency_premium',
          src: 'https://staticcontent.knowledgehook.com/content/khg/icons/item_currency_premium.png'
        },
        {
          alias: 'ph_reticle',
          src: './ui/ph_reticle.png'
        },
        {
          alias: 'target_gradient_linear',
          src: 'https://staticcontent.knowledgehook.com/content/khg/area_targeting/linear_gradient.png'
        },
        {
          alias: 'target_gradient_radial',
          src: 'https://staticcontent.knowledgehook.com/content/khg/area_targeting/radial_gradient.png'
        },
        {
          alias: 'target_indicator_topArrow',
          src: 'https://staticcontent.knowledgehook.com/content/khg/vfx/target_indicator/persistant_target_tri.png'
        },
        {
          alias: 'target_indicator_bottomHex',
          src: 'https://staticcontent.knowledgehook.com/content/khg/vfx/target_indicator/persistant_target_hex.png'
        },
        {
          alias: 'settings_bg',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/settings-background.png'
        },
        {
          alias: 'icon_volume_on',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/icon_volume_on_50.png'
        },
        {
          alias: 'icon_volume_off',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/icon_volume_off_50.png'
        },
        {
          alias: 'checkbox_bg',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/checkbox.png'
        },
        {
          alias: 'checkmark',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/icon_checkmark_50.png'
        },
        {
          alias: 'slider_thumb_diamond',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/settings/volume_btn.png'
        },
        {
          alias: 'target_tile_area_fill_64',
          src: 'https://staticcontent.knowledgehook.com/content/khg/area_targeting/rf_tile_64.png'
        },
        {
          alias: 'matchMusic',
          src: 'https://staticcontent.knowledgehook.com/content/khg/audio/soundtracks/soundtrack_trenchruns.mp3',
          data: {
            volume: 0.15,
            loop: true,
            speed: 1
          }
        },
        {
          alias: 'mapmovecursor',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/vfx/atlus_mapmovecursor/vfx_cursor.json',
          data: {
            frameRate: 0.4,
            clips: {
              ping: {
                prefix: 'move_01/vfx_',
                start: 246,
                end: 255,
                repeat: 0
              }
            },
            frames: {
              ping: 'move_01/vfx_0253'
            }
          }
        },
        {
          alias: 'vfxHit',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/vfx/hit/vfx_hit.json',
          data: {
            frameRate: 0.5,
            clips: {
              electricHitVfx1: {
                prefix: 'electric_a/vfx_hit',
                start: 1,
                end: 5,
                repeat: 0
              },
              electricHitVfx2: {
                prefix: 'electric_b/vfx_hit',
                start: 1,
                end: 7,
                repeat: 0
              },
              electricHitVfx3: {
                prefix: 'electric_c/vfx_hit',
                start: 1,
                end: 8,
                repeat: 0
              },
              mechanicHitVfx1: {
                prefix: 'mechanic_a/vfx_hit',
                start: 1,
                end: 7,
                repeat: 0
              },
              mechanicHitVfx2: {
                prefix: 'mechanic_b/vfx_hit',
                start: 1,
                end: 7,
                repeat: 0
              },
              mechanicHitVfx3: {
                prefix: 'mechanic_c/vfx_hit',
                start: 1,
                end: 7,
                repeat: 0
              },
              roleSkillHitVfx1: {
                prefix: 'raw_a/vfx_hit',
                start: 1,
                end: 7,
                repeat: 0
              },
              roleSkillHitVfx2: {
                prefix: 'raw_b/vfx_hit',
                start: 1,
                end: 9,
                repeat: 0
              },
              roleSkillHitVfx3: {
                prefix: 'raw_c/vfx_hit',
                start: 1,
                end: 6,
                repeat: 0
              }
            }
          }
        },
        {
          alias: 'vfxExplosion',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/vfx/explosion/vfx_explosion.json',
          data: {
            frameRate: 0.5,
            clips: {
              default: {
                prefix: 'explosion_',
                start: 1,
                end: 10,
                repeat: 0
              }
            }
          }
        },
        {
          alias: 'ui_active_scene',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/active-scene/ui_hud_3.json'
        },
        {
          alias: 'ui_health_bars',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/health-bars/TR_hp_bar.json'
        },
        {
          alias: 'ui_mobile',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/ui/hud/v2/atlas.json'
        }
      ]
    },
    {
      name: 'trenchRun',
      assets: [
        {
          alias: 'resultsUi_back_pattern',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/back_pattern_165x.png'
        },
        {
          alias: 'resultsUi_frame_red',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/back_pattern_165x.png'
        },
        {
          alias: 'resultsUi_frame_yellow',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/frame_yellow.png'
        },
        {
          alias: 'resultsUi_modal_back_9slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal_back_9slices.png'
        },
        {
          alias: 'resultsUi_modal_border_9slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal_border_9slices.png'
        },
        {
          alias: 'resultsUi_modal_box_3slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal_box_3slices.png'
        },
        {
          alias: 'resultsUi_modal_line_3slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal_line_3slices.png'
        },
        {
          alias: 'resultsUi_modal2_back_9slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal2_back_9slices.png'
        },
        {
          alias: 'resultsUi_modal2_back_lightGradient',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal2_back_LightGradient.png'
        },
        {
          alias: 'resultsUi_modal2_border_9slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal2_border_9slices.png'
        },
        {
          alias: 'resultsUi_modal2_inside_9slices',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/modals/modal2_inside_9slices.png'
        },
        {
          alias: 'item_card_small',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/item_card_small.png'
        },
        {
          alias: 'or_ui_result_scene',
          src: 'https://staticcontent.knowledgehook.com/content/khg/pixi/ui/results-scene/or-results-screen.json'
        },
        {
          alias: 'towerOutlineOR',
          src: 'https://staticcontent.knowledgehook.com/content/khg/tower/tower_outline_or.png'
        }
      ]
    },
    {
      name: 'captureMode',
      assets: [
        {
          alias: 'mini_map_3v3',
          src: 'https://staticcontent.knowledgehook.com/content/khg/ui/mini-map/3v3/minimap.json'
        },
        {
          alias: 'respawn-ship',
          src: 'https://staticcontent.knowledgehook.com/content/khg/respawn/respawn-ship.png'
        },
        {
          alias: 'towerOutlineCM',
          src: 'https://staticcontent.knowledgehook.com/content/khg/tower/tower_outline_cm.png'
        },
        {
          alias: 'victory_screen_sfx',
          src: 'https://staticcontent.knowledgehook.com/content/khg/audio/sfx/ui/victory_screen.mp3',
          data: {
            volume: 0.18,
            loop: false,
            speed: 1
          }
        },
        {
          alias: 'defeat_screen_sfx',
          src: 'https://staticcontent.knowledgehook.com/content/khg/audio/sfx/ui/losing_screen.mp3',
          data: {
            volume: 0.18,
            loop: false,
            speed: 1
          }
        }
      ]
    },
    {
      name: 'PlayerBotSpines',
      assets: [
        {
          alias: 'botAtlas',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9/player_bot.atlas'
        },
        {
          alias: 'botSkeleton',
          src: 'https://staticcontent.knowledgehook.com/content/khg/bot/v9/player_bot.json'
        }
      ]
    }
  ]
} as const;
